angular
    .module('app')
    .component('users', {
        templateUrl: '/templates/pages/users/users.html',
        controller: 'UsersController',
        controllerAs: 'vm',
    });